import ApiService from '@/common/api.service';
import router from '@/router/index';

let mutations = {
  toggleFullScreenNav(state) {
    state.fullScreenNav = !state.fullScreenNav;
  },
  hideFullScreenNav(state) {
    state.fullScreenNav = false;
  },
  routeChange(state, loader) {
    if (loader === 'start') {
      state.preloader = true;
    } else if (loader === 'end') {
      state.preloader = false;
    }
  },
  changePageTitle(state, title) {
    state.page_title = title;
    document.title = title + ' - ' + state.site_name;
  },

  // Custom mutations
  loadPricing(state, id) {

  }
};
export default mutations;
